import React from 'react';
import { FUNDING_LENDER_STATUS_STYLES } from '../../utils/funding/constants';

const FundingLenderStatusBadge = ({ status }) => {
  const label = status || 'Active';
  const style = FUNDING_LENDER_STATUS_STYLES[label] || FUNDING_LENDER_STATUS_STYLES.Active;

  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${style}`}>
      {label}
    </span>
  );
};

export default FundingLenderStatusBadge;
